/**
 * @generated SignedSource<<7c067030e16911b1004061d3388bd73b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserPresentationsScreenUpcomingPresentationsSection_user$data = {
  readonly id: string;
  readonly upcomingPresentations: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"PresentationItem_presentation">;
      };
    }>;
  };
  readonly " $fragmentType": "UserPresentationsScreenUpcomingPresentationsSection_user";
};
export type UserPresentationsScreenUpcomingPresentationsSection_user$key = {
  readonly " $data"?: UserPresentationsScreenUpcomingPresentationsSection_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserPresentationsScreenUpcomingPresentationsSection_user">;
};

import UserPresentationsScreenUpcomingPresentationsSectionPaginationQuery_graphql from './UserPresentationsScreenUpcomingPresentationsSectionPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "upcomingPresentations"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": 3,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": UserPresentationsScreenUpcomingPresentationsSectionPaginationQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "UserPresentationsScreenUpcomingPresentationsSection_user",
  "selections": [
    {
      "alias": "upcomingPresentations",
      "args": [
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": [
            "CREATED_AT_DESC",
            "ID_ASC"
          ]
        },
        {
          "kind": "Literal",
          "name": "timeSelection",
          "value": "UPCOMING"
        }
      ],
      "concreteType": "PresentationsConnection",
      "kind": "LinkedField",
      "name": "__UserPresentationsScreenUpcomingPresentationsSection_user_upcomingPresentations_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PresentationsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Presentation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "PresentationItem_presentation"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "__UserPresentationsScreenUpcomingPresentationsSection_user_upcomingPresentations_connection(orderBy:[\"CREATED_AT_DESC\",\"ID_ASC\"],timeSelection:\"UPCOMING\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();

(node as any).hash = "1eacbe6620b8cbcc1770d4377afe4afc";

export default node;
